import { useState } from 'react'

import { DialogContent, DialogHeader, DialogTitle, Dialog } from 'src/shared/components/ui/popups/dialog'
import { ResponsivePopup } from 'src/shared/components/ui/popups/responsive-popup'
import { SupportContent } from 'src/shared/features/support/components/support-content'

interface SupportDialogProps {
  trigger: React.ReactNode
}

export const SupportDialog = ({ trigger }: SupportDialogProps) => {
  const [isOpen, setIsOpen] = useState(false)

  return (
    <ResponsivePopup
      open={isOpen}
      onOpenChange={setIsOpen}
      trigger={trigger}
      // mobileRoute="/support"
      title="Contact support"
    >
      <SupportContent onClose={() => setIsOpen(false)} />
    </ResponsivePopup>
  )
}

interface SupportDialogControlledProps {
  open: boolean
  setOpen: (open: boolean) => void
}

/** A support popup with open state controlled from outside the component. Has a similar UI to SupportDialog. */
export const SupportDialogControlled = ({ open, setOpen }: SupportDialogControlledProps) => {
  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogContent className="max-w-[min(90vw,510px)] rounded-[20px] p-4">
        <DialogHeader className="pb-6">
          <DialogTitle className="text-2xl font-bold">Contact support</DialogTitle>
        </DialogHeader>
        <SupportContent onClose={() => setOpen(false)} />
      </DialogContent>
    </Dialog>
  )
}
